/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useTranslation} from 'react-i18next'
import {SetUserLanguage} from '../../../../redux/Slice/userSlice'
import {useAppDispatch} from '../../../../redux/hooks'
import {showErrorMessage} from '_metronic/helpers/swalHelper'

const languages = [
  {
    lang: 'fr',
    nameFr: 'French',
    nameEn: 'French',
    flag: toAbsoluteUrl('/media/flags/france.svg'),
  },
  {
    lang: 'en',
    nameFr: 'English',
    nameEn: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
]

const Languages: FC = () => {
  const {i18n} = useTranslation()
  const {t} = useTranslation()
  const dispatch = useAppDispatch()

  const handleChangeLanguage = (lang) => {
    dispatch(SetUserLanguage(lang)).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        i18n.changeLanguage(lang)
        window.location.reload()
      } else if (res.meta.requestStatus === 'rejected') {
        showErrorMessage(t('MESSAGES.SERVER_ERROR'))
      }
    })
  }

  const currentLanguage = languages.find((x) => x.lang === i18n.language)
  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          <span className='fa fa-globe px-1'></span>
          {t('GLOBAL.LANGUAGE')}
          <span className='fs-8 rounded bg-default px-3'>
            {(currentLanguage?.lang === 'fr' && currentLanguage.nameFr) ||
              (currentLanguage?.lang === 'en' && currentLanguage.nameEn)}
            <img
              className='w-15px h-15px rounded-1 ms-2 mx-1'
              src={currentLanguage?.flag}
              alt='current'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={() => {
              handleChangeLanguage(l.lang)
            }}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
            >
              <span className='symbol symbol-20px mx-2'>
                <img className='rounded-1 mx-1' src={l.flag} alt='img' />
              </span>
              {currentLanguage?.lang === 'fr'
                ? l.nameFr
                : currentLanguage?.lang === 'en' && l.nameEn}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
